import { Helmet } from 'react-helmet-async';

const SEOHead = () => {
  const businessInfo = {
    name: "Roger'S Club Barberia",
    address: "Via Tanzini, 41, 50065 Pontassieve (FI), Italy",
    phone: "+39 331 885 7252",
    rating: 5.0,
    reviewCount: 60,
    image: "https://barberia-preview.preview.emergentagent.com/og-image.png",
    url: "https://barberia-preview.preview.emergentagent.com",
    instagram: "https://www.instagram.com/rogers_club_barberia"
  };

  const schemaOrg = {
    "@context": "https://schema.org",
    "@type": "HairSalon",
    "name": businessInfo.name,
    "image": businessInfo.image,
    "description": "Roger's Concept Gentleman Club. Identità, esperienza, visione che va oltre la professione. Un modo unico per trasformare il concetto di Barberia in un Brand che lascia il segno.",
    "@id": businessInfo.url,
    "url": businessInfo.url,
    "telephone": businessInfo.phone,
    "priceRange": "€€",
    "taxID": "07183440481",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Via Tanzini, 41",
      "addressLocality": "Pontassieve",
      "postalCode": "50065",
      "addressRegion": "FI",
      "addressCountry": "IT"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 43.7716,
      "longitude": 11.4319
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        "opens": "09:00",
        "closes": "13:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        "opens": "15:30",
        "closes": "19:30"
      }
    ],
    "sameAs": [
      businessInfo.instagram
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": businessInfo.rating,
      "reviewCount": businessInfo.reviewCount,
      "bestRating": "5",
      "worstRating": "1"
    }
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>Roger'S Club Barberia Pontassieve | Gentleman Club Barbershop</title>
      <meta 
        name="title" 
        content="Roger'S Club Barberia Pontassieve | Gentleman Club Barbershop" 
      />
      <meta 
        name="description" 
        content="Roger'S Club Barberia a Pontassieve (FI): barberia elegante e professionale. Taglio uomo, barba tradizionale, servizi premium in atmosfera esclusiva. ⭐5.0 (60 recensioni)" 
      />
      <meta 
        name="keywords" 
        content="barberia pontassieve, barbiere pontassieve, taglio uomo pontassieve, barba pontassieve, roger's club, gentleman club, barbershop firenze, rasatura tradizionale" 
      />
      <meta name="author" content="Roger'S Club Barberia" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Italian" />
      <meta name="geo.region" content="IT-FI" />
      <meta name="geo.placename" content="Pontassieve" />
      <meta name="geo.position" content="43.7716;11.4319" />
      <meta name="ICBM" content="43.7716, 11.4319" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="business.business" />
      <meta property="og:url" content={businessInfo.url} />
      <meta 
        property="og:title" 
        content="Roger'S Club Barberia Pontassieve | Gentleman Club Barbershop" 
      />
      <meta 
        property="og:description" 
        content="Più di una barberia. Un'esperienza. Roger'S Club: taglio uomo, barba tradizionale e servizi premium in atmosfera esclusiva a Pontassieve (FI)." 
      />
      <meta property="og:image" content={businessInfo.image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:site_name" content="Roger'S Club Barberia" />
      <meta property="business:contact_data:street_address" content="Via Tanzini, 41" />
      <meta property="business:contact_data:locality" content="Pontassieve" />
      <meta property="business:contact_data:region" content="Firenze" />
      <meta property="business:contact_data:postal_code" content="50065" />
      <meta property="business:contact_data:country_name" content="Italy" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={businessInfo.url} />
      <meta 
        property="twitter:title" 
        content="Roger'S Club Barberia Pontassieve | Gentleman Club Barbershop" 
      />
      <meta 
        property="twitter:description" 
        content="Più di una barberia. Un'esperienza. Roger'S Club: taglio uomo, barba tradizionale e servizi premium in atmosfera esclusiva a Pontassieve (FI)." 
      />
      <meta property="twitter:image" content={businessInfo.image} />

      {/* Canonical Link */}
      <link rel="canonical" href={businessInfo.url} />

      {/* Schema.org JSON-LD */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrg) }} />

      {/* Additional SEO */}
      <meta name="theme-color" content="#d4af37" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content="Roger's Club" />
    </Helmet>
  );
};

export default SEOHead;
